import * as React from "react";
import { ParallaxProvider, ParallaxBanner } from "react-scroll-parallax";
import { centered } from "./hero.module.scss";
import { narrowScreen } from "./../../assets/scss/variables.module.scss";
import "./../../style.scss";
import IDMCLogo from "./../../images/IDMC_logo_white.svg";
import NRCLogo from "./../../images/nrc-image.png";
import { Container } from "@mui/material";
import { Facebook, Twitter, Instagram, YouTube } from "@mui/icons-material";

/**
 * Component Name: Hero
 * Description: Parallax banner based on react-scroll-parallax
 *
 * Prop list:
 * imageUrl => url of background image
 * id => Unique id of the section
 * bgColor => color of overlay - do not use for no overlay
 * bgOpacity => opacity of overlay - do not use if no overlay
 * txtColor => color of text inside (children)
 *
 * Accepts children for text inside banner
 *
 */

const Footer = ({
  id,
  imageUrl,
  size,
  bgColor,
  bgOpacity,
  txtColor,
  children,
}) => {
  const bannerHeightHalf = {
    minHeight: "300px",
    height: "50vh",
  };

  const bannerBody = {
    maxWidth: narrowScreen,
    margin: "auto",
  };
  const overlay = {
    width: "100%",
    height: "100%",
    backgroundColor: bgColor,
    opacity: bgOpacity ? bgOpacity : "0",
  };
  const textColor = {
    color: txtColor ? txtColor : "#000000",
  };
  const posAbs = {
    position: "absolute",
    bottom: "20px",
    right: "20px",
  };

  return (
    <ParallaxProvider>
      <ParallaxBanner
        id="footer"
        layers={[
          {
            image: `${imageUrl}`,
            speed: -20,
            children: <div style={overlay}>Overlay</div>,
          },
          {
            speed: 0,
            children: (
              <Container maxWidth="lg" style={{ textColor }}>
                <div
                  className="mt-5"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <div className='row mt-3'> */}
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            {/* <StaticImage
                      placeholder='none'
                      src='./../../images/IDMC_logo_white.svg'
                      alt='IDMC logo'
                      layout='constrained'
                      height={30}
                    /> */}
                            <img src={IDMCLogo} height="30" />
                          </div>
                          <div>
                            {/* <StaticImage
                      placeholder='none'
                      src='./../../images/nrc-image.png'
                      alt='NRC logo'
                      layout='constrained'
                      height={45}
                    /> */}
                            <img src={NRCLogo} height="45" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <h2 style={{ fontSize: "1.7em" }}>Contacto</h2>
                        <p>Internal Displacement Monitoring Centre (IDMC)</p>
                        <p>
                        Humanitarian Hub Office, La Voie Creuse 16, 1202 Geneva <br />
                          Consultas generales:{" "}
                          <a href="mailto:info@idmc.ch">info@idmc.ch</a> <br />
                          Consultas de prensa:{" "}
                          <a href="mailto:media@idmc.ch">media@idmc.ch</a>
                        </p>
                      </div>
                      <div className="col-md-6 mb-2">
                        <h2 style={{ fontSize: "1.7em" }}>Sobre nosotros</h2>
                        <p>
                          El Informe Mundial sobre Desplazamiento Interno (GRID)
                          del IDMC es la principal fuente mundial de datos y
                          análisis sobre desplazamiento interno. Desde nuestra
                          creación en 1998 como parte del Consejo Noruego para
                          Refugiados (NRC), hemos ofrecido un servicio riguroso,
                          independiente y de confianza la comunidad
                          internacional. Nuestro trabajo sirve como fundamento
                          para la toma de decisiones políticas y operativas
                          destinadas a mejorar la vida de los millones de
                          personas que viven en situación de desplazamiento
                          interno, o que corren el riesgo de convertirse en
                          desplazados en el futuro.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          Copyright © Observatorio de Desplazamiento Interno
                          (IDMC). Salvo que se indique lo contrario, todo el
                          material de esta página se puede compartir libremente,
                          a condición de que se mencione al IDMC como fuente.
                          Los materiales no se pueden adaptar sin contar con el
                          permiso previo del IDMC.
                        </p>
                      </div>
                      <div className="col-md-6">
                        <a href="https://www.facebook.com/IDMC.Geneva">
                          <Facebook sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="http://twitter.com/IDMC_Geneva">
                          <Twitter sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="http://www.linkedin.com/company/internal-displacement-monitoring-centre-idmc-">
                          <Instagram sx={{ color: "#ffffff" }} />
                        </a>{" "}
                        <a href="https://www.youtube.com/channel/UCKEgRCcKKPNezkF3FLlfBRQ">
                          <YouTube sx={{ color: "#ffffff" }} />
                        </a>{" "}
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </Container>
            ),
          },
        ]}
        className=" footerHeight "
      ></ParallaxBanner>
    </ParallaxProvider>
  );
};

export default Footer;
